import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  // mode: 'history',
  // base: process.env.BASE_URL,
  base: '/gap-web-password',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/app-cloud/home/index.vue'),
    },
    {
      path: '/pwd/1',
      redirect: 'pwd/reset/1',
    },
    {
      path: '/pwd/2',
      redirect: 'pwd/unfreeze/1',
    },
    {
      path: '/editPwd/1',
      redirect: 'edit/password/1',
    },
    {
      path: '/editPwd/2',
      redirect: 'edit/password/2',
    },
    {
      path: '/pwd/:type/:step',
      name: 'pwd',
      component: () => import(/* webpackChunkName: "reset" */ '@/views/app-cloud/reset/index.vue'),
    },
    {
      path: '/edit/:type/:step',
      name: 'editPwd',
      component: () => import(/* webpackChunkName: "edit" */ '@/views/app-cloud/edit/index.vue'),
    },
    {
      path: '/statePage/:type',
      name: 'statePage',
      component: () => import(/* webpackChunkName: "state-page" */ '@/views/app-cloud/statePage/index.vue'),
    },
    {
      path: '/*',
      redirect: '/',
    },
  ],
});
